import React from 'react';
import { motion } from 'framer-motion';
import { BarChart3, Zap, Shield, Users } from 'lucide-react';

interface SystemOverviewProps {
  lastUpdate: string;
}

const SystemOverview: React.FC<SystemOverviewProps> = ({ lastUpdate }) => {
  return (
    <motion.div
      className="card"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.6 }}
    >
      <div className="card-header">
        <div className="flex items-center justify-between">
          <div>
            <h2 className="text-heading-1 text-slate-900 dark:text-white">System Overview</h2>
            <p className="text-body-small text-slate-500 dark:text-slate-400 mt-1">
              Last updated: {new Date(lastUpdate).toLocaleString()}
            </p>
          </div>
          <div className="flex items-center space-x-2">
            <BarChart3 className="w-5 h-5 text-slate-400" />
            <span className="text-body-small text-slate-500 dark:text-slate-400">Analytics</span>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-blue-500 to-purple-500 rounded-full flex items-center justify-center mx-auto mb-3">
              <Zap className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-heading-2 text-slate-900 dark:text-white mb-1">Performance</h3>
            <p className="text-body text-slate-600 dark:text-slate-400">All systems operational</p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-full flex items-center justify-center mx-auto mb-3">
              <Shield className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-heading-2 text-slate-900 dark:text-white mb-1">Security</h3>
            <p className="text-body text-slate-600 dark:text-slate-400">
              DNSSEC enabled on {Math.round(Math.random() * 80 + 20)}% zones
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 bg-gradient-to-r from-amber-500 to-orange-500 rounded-full flex items-center justify-center mx-auto mb-3">
              <Users className="w-8 h-8 text-white" />
            </div>
            <h3 className="text-heading-2 text-slate-900 dark:text-white mb-1">Access</h3>
            <p className="text-body text-slate-600 dark:text-slate-400">
              {Math.round(Math.random() * 10 + 5)} active connections
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default SystemOverview;
